<template>
  <div class="overall-bg">
    <b-container fluid="xl">
      <b-row>
        <b-col>
          <BacktoPage path="/Masters"></BacktoPage>
          <Headerlayout :headertext="$t('Supppliers.DeliveryTerms.List')"
            :contenttext="$t('Supppliers.DeliveryTerms.TableHeaderContent')">
          </Headerlayout>
        </b-col>
      </b-row>
      <b-row class="py-3">
        <b-col>
          <div v-if="windowWidth > 545">
            <SkeletonTableLoader :columns="headers" :loading="loading" />
            <div v-if="!loading">
              <MasterEmpty v-if="items.length === 0 && !loading" eheader="Delivery Terms" econtent="Delivery Terms"
                eimg="/src/assets/Img/icons/deliveryterms.svg" @createNew="IsAdd" />
              <div class="table-width-80">
                <Tableview v-if="items.length !== 0" :value="items" :paginator="true" class="p-datatable-gridlines"
                  :rows="10" :rowHover="true" filterDisplay="menu" :loading="loading" responsiveLayout="scroll"
                  :columns="headers" @row-click="RowClick" :globalFilterFields="globalFilterFields" :filters="filters"
                  selectionMode="single" :exceldownload="true">
                  <template v-slot:Add>
                    <span class="add">
                      <AddButton @click="IsAdd()" :btnname="$t('btn.plusaddnew')" class="float-rights my-3">
                      </AddButton>
                    </span>
                  </template>
                  <template v-slot:exceldownload>
                    <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                      PageName="Deliveryterms Master" :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
                  </template>
                  <template v-slot:Status="{ data }">

                    <OrangeStatus name="InActive" v-if="data.IsActive == '0'" />
                    <GreenStatus name="Active" v-if="data.IsActive == '1'" />
                  </template>
                  <template v-slot:action="{ data }">
                    <span>
                      <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                        @click="toggle($event, data)" />
                    </span>
                  </template>
                </Tableview>
              </div>
            </div>
          </div>
          <div v-if="windowWidth <= 545">
            <MobileLoader v-if="loading" v-for="item in 5" />
            <div v-if="!loading">
              <MasterEmpty v-if="items.length === 0 && !loading" eheader="Delivery Terms" econtent="Delivery Terms"
                eimg="/src/assets/Img/icons/deliveryterms.svg" @createNew="IsAdd" />
              <MobileViewCardHeader>
                <template v-slot:mobilecard>
                  <div class="mobile-card" v-for="item in items">
                    <div class="d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <p class="light-name">{{ item.DeliTermsCode }}</p>
                        <p class="name">{{ item.DeliTermsDesc }}</p>
                      </div>
                      <div class="d-flex align-items-center">
                        <div>

                          <OrangeStatus name="InActive" v-if="item.IsActive == '0'" />
                          <GreenStatus name="Active" v-if="item.IsActive == '1'" />
                        </div>
                        <i class="pi pi-ellipsis-v" @click="toggle($event, item)"></i>
                      </div>
                    </div>
                  </div>
                </template>
              </MobileViewCardHeader>
            </div>
          </div>
          <DeliveryTermsCreation v-model:trigger="showDialog" v-if="showDialog" v-model:selected-item="editItems"
            @load="IsShow(), (showDialog = false)" @close="showDialog = false" @loaderhide="loading = false"
            @loadershow="loading = true" :OperationID="ObjOperationId" :EntityId="EntityData.EntityId" />
        </b-col>
      </b-row>
    </b-container>
  </div>
  <Menu ref="menu" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
  <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(dataEdit)" @no="Editmodel = false"
    :content="$t('confirmation.editcontent')" />
  <DeleteConfirmationVue :DeleteModel="Deletemodel" @yes="Isdelete(dataEdit)" :content="contentdel"
    @no="Deletemodel = false" />
  <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
  <ActivatedSuccessfully :visible="pop.activatepop" @ok="closetrigger()" />
  <InActivatedSuccessfully :visible="pop.inactivepop" @ok="closetrigger()" />
  <Mapping :visible="MappingPop.visible" @ok="closetrigger()" :content="MappingPop.content" />
  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, h, computed, onUnmounted } from "vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";
import DeliveryTermsCreation from "../../../Masters/Supplier/DeliveryTerms/DeliveryTermscreation.vue";
import DeliveryTermsService from "../../../../../../modules/Inventory/Service/DeliveryTermsService";
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { useI18n } from 'vue-i18n';
import { FilterMatchMode, FilterOperator } from "primevue/api";
import DeleteConfirmationVue from "../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import Mapping from "../../../../../../components/FormComponents/Mapping.vue";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import ActivatedSuccessfully from "../../../../../../components/FormComponents/ActivateSuccessfully.vue";
import InActivatedSuccessfully from "../../../../../../components/FormComponents/InActivateSuccessfully.vue";

import MastersService from "../../../../Service/MastersService";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../../Service/AccessControl";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import ExportOption from "../../../../../../components/FormComponents/Export.vue";

export default defineComponent({
  components: {
    EditConfirmation,
    DeletedSuccessfully,
    DeleteConfirmationVue,
    BacktoPage,
    Headerlayout,
    DeliveryTermsCreation,
    Tableview,
    Mapping,
    MasterEmpty,
    Loader,
    ActivatedSuccessfully,
    InActivatedSuccessfully,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    ExportOption,
  },
  setup() {
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });

    const toast = useToast();
    const showDialog = ref(false);
    const dataEdit = ref();
    const Editmodel = ref(false);
    const { t } = useI18n();
    const rowFocus = ref(false);
    const editItems = ref();
    const Deletemodel = ref(false);
    const deletepop = ref(false);
    let MappingPopup = ref(false);
    let ContentName = ref("");
    let delId = 0;
    let objectdata = ref({});
    let InActivevisible = ref();
    let Editvisible = ref();

    let Activevisible = ref();
    let Deletevisible = ref();
    const items: any = ref([]);
    function IsAdd() {
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        showDialog.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }
    let loading = ref(false);
    function RowClick(event: any) {
      debugger;
      Editmodel.value = true;
      rowFocus.value = true;
      dataEdit.value = event.data;
    }

    function IsConfirmEdit(data) {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Edit");
      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        Editmodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }
    const MappingPop = ref({
      visible: false,
      content: "",
    });
    const contentdel = ref("");
    const pop = ref({
      activatepop: false,
      inactivepop: false,
    });

    // Popup-Close
    function closetrigger() {
      deletepop.value = false;
      pop.value.activatepop = false;
      pop.value.inactivepop = false;
      MappingPop.value.visible = false;
    }
    function closemapping() {
      MappingPopup.value = false;
      Deletemodel.value = false;
    }

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let EntityData;
    if (SessionEntityData !== null) {
      EntityData = JSON.parse(SessionEntityData);
    }
    //

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    onMounted(() => {
      window.addEventListener("resize", handleResize);
      document.addEventListener("keydown", onKeyUp);
      IsShow();
      FunctionRights();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    async function FunctionRights() {
      //
      debugger;
      const response = await MastersService.CheckMenuRights(
        EntityData.EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);
      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
    }

    function onKeyUp(event: any) {
      debugger;

      console.log(dataEdit.value);
      if (
        (event.key == "e" ||
          (Editmodel.value == false && event.key == "Enter")) &&
        rowFocus.value == true &&
        Deletemodel.value == false &&
        showDialog.value == false
      ) {
        // IsEdit(dataEdit.value)
        Editmodel.value = true;
      } else if (
        event.altKey &&
        event.key == "n" &&
        Editmodel.value == false &&
        Deletemodel.value == false
      ) {
        IsAdd();
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Deletemodel.value == true &&
        Editmodel.value == false &&
        rowFocus.value == true
      ) {
        Isdelete(dataEdit.value);
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Editmodel.value == true &&
        rowFocus.value == true
      ) {
        IsEdit(dataEdit.value);
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Editmodel.value == true
      ) {
        Editmodel.value = false;
      } else if (
        event.key == "d" &&
        rowFocus.value == true &&
        showDialog.value == false &&
        Editmodel.value == false
      ) {
        Deletemodel.value = true;
        Editmodel.value = false;
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Deletemodel.value == true
      ) {
        Deletemodel.value = false;
      } else if (event.key == "Escape" && deletepop.value == true) {
        deletepop.value = false;
      } else if (event.key == "Enter" && rowFocus.value == false) {
        Editmodel.value = false;
      } else if (event.key == "Escape" && MappingPopup.value == true) {
        MappingPopup.value = false;
        Deletemodel.value = false;
      }
    }

    //dataTable header
    const headers = [
      {
        header: t('Supppliers.DeliveryTerms.sno'),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t('Supppliers.DeliveryTerms.Code'),
        field: "DeliTermsCode",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t('Supppliers.DeliveryTerms.Remarks'),
        field: "DeliTermsDesc",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "largewidth",
        bodyclass: "boldclass text_overflow1",
      },
      {
        header: t('Supppliers.DeliveryTerms.Status'),
        field: "ActiveStatus",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "bluecolor",
        slot: "Status",
      },
      {
        header: "",
        field: "action",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      DeliTermsCode: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      DeliTermsDesc: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      ActiveStatus: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
    };

    const filteredColumns = computed(() => {
      return headers.filter((col) => col.field !== "id");
    });

    const globalFilterFields = ref(headers.map((col) => col.field));

    let ExportOption = ref("");
    let ExportList = ref([]);


    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;

        const response = await DeliveryTermsService.getdata();
        console.log(response.data);
        let count = 0;

        response["result"] = response["result"]
          .filter((items) => items.HospitalId == usersData.organizationId)
          .map((item) => {
            count = count + 1;
            item.RowNumber = count;
            item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
            return item;
          });


        ExportList.value = response["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          return filteredItem;
        });

        console.log("ContactTable Data", items.value);

        loading.value = false;
      } catch (error) {
        loading.value = false;
      }
    }

    const IsShow = async () => {
      debugger;

      loading.value = true;
      try {
        const response = await DeliveryTermsService.getdata();
        console.log(response.data);
        let count = 0;

        response["result"] = response["result"]
          .filter((items) => items.HospitalId == usersData.OrganizationId)
          .map((item) => {
            count = count + 1;
            item.RowNumber = count;
            item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
            return item;
          });

        items.value = response["result"];
        loading.value = false;
        console.log(items.value);
      } catch (error) {
        loading.value = false;
        alert(error);
      }
    };

    //Edit Box
    function IsEdit(data) {
      debugger;
      editItems.value = data;
      showDialog.value = true;
      Editmodel.value = false;
    }
    const Isdelete = async (data) => {
      loading.value = true;
      debugger;
      try {
        let response: any = "";
        if (data.ActiveStatus == 0) {
          response = await DeliveryTermsService.deletedata(data.Id);
        } else {
          let status = data.ActiveStatus == 1 ? true : false;
          response = await DeliveryTermsService.active(data.Id, status);
        }
        let message = response["ErrorInfo"].ErrorCode;
        loading.value = false;
        if (response["result"] != "False" && message == null) {
          Deletemodel.value = false;
          MappingPop.value.content = response["result"];
          MappingPop.value.visible = true;
        } else if (message == null) {
          if (data.ActiveStatus == 1) {
            pop.value.activatepop = true;
          } else if (data.ActiveStatus == 2) {
            pop.value.inactivepop = true;
          } else {
            deletepop.value = true;
          }
          Deletemodel.value = false;
          rowFocus.value = false;
          IsShow();
        }
      } catch (error) {
        alert(error);
      }
    };

    function IsConfirmDel(data, Status) {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Delete");
      if (permissionResult.hasPermission) {
        data.ActiveStatus = Status;
        dataEdit.value = data;
        Editmodel.value = false;
        if (Status == 1) {
          contentdel.value = t('confirmation.activecontent');
        } else if (Status == 2) {
          contentdel.value = t('confirmation.inactivecontent');
        } else {
          contentdel.value = t('confirmation.deletecontent');
        }
        Deletemodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    const toggle = (event, data) => {
      debugger;
      console.log(event);
      objectdata.value = data;

      if (data.IsActive == 0) {
        InActivevisible.value = false;
        Activevisible.value = true;
        Editvisible.value = false;
      } else {
        InActivevisible.value = true;
        Activevisible.value = false;
        Editvisible.value = true;
      }

      menu.value.toggle(event);
    };
    const menu = ref();
    const itemListed = ref([
      {
        items: [
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: Editvisible,
            command: async () => {
              IsConfirmEdit(objectdata.value);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: true,
            command: async () => {
              IsConfirmDel(objectdata.value, 0);
            },
          },

          {
            label: "Active",
            icon: "editicon pi pi-check-circle",
            visible: Activevisible,
            command: async () => {
              IsConfirmDel(objectdata.value, 1);
            },
          },
          {
            label: "InActive",
            icon: "deleteicon pi pi-minus-circle",
            visible: InActivevisible,
            command: async () => {
              IsConfirmDel(objectdata.value, 2);
            },
          },
        ],
      },
    ]);

    return {
      ObjOperationId,
      contentdel,
      pop,
      MappingPop,
      toggle,
      menu,
      itemListed,
      ContentName,
      MappingPopup,
      closemapping,
      IsEdit,
      IsAdd,
      RowClick,
      dataEdit,
      Editmodel,
      IsConfirmEdit,
      IsConfirmDel,
      showDialog,
      editItems,

      Deletemodel,
      deletepop,
      closetrigger,
      IsShow,
      Isdelete,
      headers,
      items,
      filters,
      globalFilterFields,
      filteredColumns,
      loading,
      windowWidth,
      ExportExcel,
      ExportOption,
      ExportPDF,
      ExportList,
      EntityData
    };
  },
});
</script>
<style lang="scss" scoped>
.mobilecategoryname {
  font-size: 16px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin-top: -7px;
}

.mobilestorename {
  font-size: 14px;
  color: #999999;
}
</style>
